<template>
  <item-nav :id="$attrs['id']">
    <item-nav-item :label="$t('layout.nav.admin.roomTypeNav.overview')" link="roomTypes" />
    <item-nav-group v-if="!isEmpty(roomTypes)" :open="true" :label="$t('layout.nav.admin.roomTypeNav.roomTypes')">
      <item-nav-group-item v-for="roomType in roomTypes"
                           v-if="!roomType.deleted"
                           :label="getName(roomType.name)"
                           :params="routeParams(roomType.id)"
                           :key="roomType.id"
                           link="roomType" />
    </item-nav-group>
    <item-nav-group v-if="!isEmpty(deletedRoomTypes)" :open="false" :label="$t('layout.nav.admin.roomTypeNav.deletedRoomTypes')">
      <item-nav-group-item v-for="roomType in deletedRoomTypes"
                           :label="getName(roomType.name)"
                           :params="routeParams(roomType.id)"
                           :key="roomType.id"
                           link="roomType" />
    </item-nav-group>

  </item-nav>
</template>

<script>

import { cloneDeep, isNil, isEmpty } from 'lodash';
import ItemNavGroup from '../ItemNavGroup';
import ItemNavGroupItem from '../ItemNavGroupItem';
import HotelmeisterMixin from '../../../../../mixins/HotelmeisterMixin';

export default {
  name: 'RoomTypeNav',
  components: { ItemNavGroupItem, ItemNavGroup },

  mixins: [HotelmeisterMixin],
  props: [],

  data() {
    return {
      roomTypes: [],
    };
  },

  computed: {
    deletedRoomTypes: function () {
      return this.roomTypes.filter(it => it.deleted === true);
    },
  },

  created: function () {
    this.axios.get(this.serviceUrls.roomType.list(this))
      .then((response) => {
        this.roomTypes = response.data.data;
      });

    this.$serviceBus.$on('roomType.list', (data) => {
      if (isNil(data)) {
        this.axios.get(this.serviceUrls.roomType.list(this))
          .then((response) => {
            this.roomTypes = response.data.data;
          });
      } else {
        this.roomTypes = data;
      }
    });
  },

  mounted: function () {
    this.$emit('widenav', true);
  },

  methods: {
    getName(name) {
      if (isNil(name)) return '-';
      let ret = null;

      ret = name[this.$shortLocale] || name[this.hotelSettings.details.primaryLanguage];

      if (!isEmpty(ret)) return ret;

      return name[this.hotelSettings.details.primaryLanguage];
    },
    routeParams(roomTypeId) {
      return {
        roomTypeId: roomTypeId,
      };
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  // @import '~styles/main';
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/nav/admin/RoomTypeNav.vue